import React, { useState, useRef, useEffect } from "react";
import { FaKey, FaUserShield, FaTrash, FaEdit, FaEllipsisV } from "react-icons/fa";
import "./UserCard.css";

// Mapeia o role para texto amigável
const formatRole = (role) => {
  switch (role) {
    case "owner":    return "Administrador";
    case "sub":      return "Usuário";
    case "readonly": return "Somente leitura";
    default:         return role;
  }
};

export default function UserCard({ user, onEdit, onChangePassword, onChangePolicy, onDelete }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Fecha o submenu ao clicar fora
  useEffect(() => {
    function handleOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  return (
    <div className="user-card" ref={ref}>
      <div className="user-info">
        <div className="user-name">{user.firstName} {user.lastName}</div>
        <div className="user-email">{user.email}</div>
        <div className="user-role">{formatRole(user.role)}</div>
      </div>

      <div className="user-actions">
        {/* Botão direto para excluir */}
        <button
          className="btn-delete"
          title="Excluir Usuário"
          onClick={() => onDelete(user)}
        >
          <FaTrash />
        </button>

        {/* Dropdown para outras ações */}
        <button
          className="btn-more"
          onClick={() => setOpen(prev => !prev)}
          title="Mais opções"
        >
          <FaEllipsisV />
        </button>

        {open && (
          <ul className="dropdown-menu">
            <li onClick={() => onEdit(user)}><FaEdit /> Editar</li>
            <li onClick={() => onChangePassword(user)}><FaKey /> Alterar senha</li>
            <li onClick={() => onChangePolicy(user)}><FaUserShield /> Alterar política</li>
          </ul>
        )}
      </div>
    </div>
  );
}
